import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        defaultFilter: '<',
        filter: '='
    },
    template: `
        <div class="table-filters">
            <form ng-submit="vm.applyFilter()" class="form form-filter">
                <div class="fields">
                    <div class="row row-md">
                        <label class="label">{{ 'filter.E-mail content' | translate }}</label>
                        <div class="items"><input ng-model="vm.filter.keyword" type="text" class="form-control"></div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor (NotificationService) {
        this.NotificationService = NotificationService;
    }

    applyFilter () {
        this.list.fetch(this.filter).then(() => {
            this.NotificationService.getTranslationStatusClasses(this.list);
        });
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/templates/filter/index.js